import { REACT_QUERY_KEYS, bridgeRequest } from 'common'
import { TPurposesResponse } from 'common/types'
import { TEndpoint, TEntity, TUserType } from 'contexts/app-context/types'
import { entityPayloadMap } from 'contexts/app-context/types/app-context/components/utils'

import { queryOptions } from '@tanstack/react-query'

import { isPurposesUsQueryEnabled } from './isPurposesUsQueryEnabled'

interface GetPurposesUsQueryParams {
  endpoint?: TEndpoint
  userCountry?: string
  userSelectedEntity?: TEntity
  userAccountType?: TUserType
  productId?: string
  isUSBranch: boolean
}

export const getPurposesUsQueryKey = ({
  userCountry,
  userSelectedEntity,
  userAccountType,
  productId,
}: Pick<
  GetPurposesUsQueryParams,
  'userCountry' | 'userSelectedEntity' | 'userAccountType' | 'productId'
>) => [REACT_QUERY_KEYS.US_PURPOSES, userCountry, userSelectedEntity, userAccountType, productId]

export const getPurposesUsQueryOptions = ({
  endpoint,
  userCountry,
  userSelectedEntity,
  userAccountType,
  productId,
  isUSBranch,
}: GetPurposesUsQueryParams) =>
  queryOptions({
    queryKey: getPurposesUsQueryKey({
      userCountry,
      userSelectedEntity,
      userAccountType,
      productId,
    }),
    queryFn: () => {
      const customHeaders = userCountry &&
        userSelectedEntity && {
          'x-inter-user-org': userCountry,
          'x-inter-account-org': entityPayloadMap[userSelectedEntity],
        }

      if (!endpoint || !userSelectedEntity || !productId) {
        throw new Error('No get purposes endpoint available')
      }

      const completeEndpoint = {
        ...endpoint,
        url: `app-pf${endpoint.url}${userCountry}/${userAccountType}/${userSelectedEntity}/${productId}`,
        headers: { ...endpoint.headers, ...customHeaders },
      }

      return bridgeRequest<TPurposesResponse<TUserType>>({
        endpoint: completeEndpoint,
        returnAllResponse: false,
        isUSBranch,
      })
    },
    enabled: isPurposesUsQueryEnabled({
      endpoint,
      userCountry,
      userSelectedEntity,
      userAccountType,
      productId,
    }),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 6,
  })
